export default {
    apiKey: "AIzaSyCAvfnwKNQjHjlhAkuSsSteCuzy127Ym40",
    authDomain: "generacion-talentos.firebaseapp.com",
    projectId: "generacion-talentos",
    storageBucket: "generacion-talentos.appspot.com",
    messagingSenderId: "113317317398",
    appId: "1:113317317398:web:ba1b9c6d0debbdfb36de37",
    measurementId: "G-V6P4GPFBCK"
};